import React from 'react';
import { styled } from '@mui/material/styles';
import { Modal, Paper } from '@mui/material';

const PREFIX = 'ModalContainer';

const classes = {
  modal: `${PREFIX}-modal`,
};

const StyledModal = styled(Modal)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',

  [`& .${classes.modal}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
}));

// @jmossesgeld This component's props are badly designed. What is the point of setIsOpen?
// naming it setIsOpen is confusing. We are also passing onClose as a prop, and overriding the
// explicit onClose prop of the Modal component. We should be consistent and have a single way
// of closing the modal.
const ModalContainer = ({ isOpen, setIsOpen, children, ...props }) => (
  <StyledModal className={classes.modal} open={isOpen} onClose={() => setIsOpen(false)} {...props}>
    <Paper sx={{ p: 2, m: 1 }}>{children}</Paper>
  </StyledModal>
);

export default ModalContainer;
